import type { Configuration } from '../../../types/Configuration';
import getLanguages from './getLanguages';

const findDefaultLanguage = (config: Configuration) => {
  // calculate the default language
  const languages = getLanguages(config);

  const defaultLanguageCode = config.language ?? config.defaultLanguage;

  return languages.find((x) => x.code === defaultLanguageCode) ?? languages[0];
};

export default findDefaultLanguage;
